import { useBearAuthSession } from '@bear-auth/react';

import { useRequestUserAccess } from '@/modules/api/codegen';

import { useAccessDeniedStore } from '../../../hooks';

export const useRequestAccess = () => {
    const { accessToken: fallbackAccessToken } = useAccessDeniedStore();
    const { data: bearAuthSession } = useBearAuthSession();

    const accessToken = bearAuthSession?.accessToken ?? fallbackAccessToken;

    const requestAccessMutation = useRequestUserAccess({ request: { headers: { Authorization: `Bearer ${accessToken}` } } });

    return requestAccessMutation;
};
